module.exports = __webpack_public_path__ + "img/1524314492.37eb0417.jpg";